(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /*
   * PDP media/info height parity — deterministic integer-px SNAP (safety net).
   *
   * The CSS in section-main-product.css already makes the single-image media
   * column equal max(9:16, infoColumn) via flex-stretch + a ::before floor, and
   * paints every box studio-grey so no seam can read white. This controller adds
   * two things and NOTHING that can regress:
   *   1. It reads the media-wrapper's ALREADY flex-stretched rendered height
   *      (the truth the CSS produced) and pins .product__media to Math.ceil() of
   *      it, erasing any fractional-pixel box so no sub-pixel seam exists at all.
   *   2. It re-asserts the fill inline, so even in a browser without :has()
   *      support the media still fills (graceful fallback, no crash).
   *
   * LOOP-SAFE BY CONSTRUCTION: we WRITE only to .product__media, which lives
   * inside the absolutely-positioned gallery (out of flow) and therefore cannot
   * feed back into the wrapper height we MEASURE. One pass, always terminates.
   * We deliberately do NOT measure the info container (Candidate-2's bug); the
   * flex row has already equalized to the info-WRAPPER incl. its 3rem/4rem
   * padding, and the wrapper height reflects that exactly.
   */
  (function () {
    'use strict';

    var DESKTOP = '(min-width: 990px)';
    // NOTE: the former 16/9 portrait floor is removed — the media box now
    // matches the info column height exactly (image crops via object-fit).
    var mql = window.matchMedia ? window.matchMedia(DESKTOP) : null;

    function isDesktop() {
      return mql ? mql.matches : window.innerWidth >= 990;
    }

    function singleImage(mediaWrapper) {
      // Scope to the gallery inside the wrapper (the modal/lightbox is rendered
      // OUTSIDE the wrapper), so this counts only real gallery items.
      return mediaWrapper.querySelectorAll('.product__media-item').length === 1;
    }

    function relinquish(mediaBox, container, mediaWrapper) {
      if (mediaBox) {
        mediaBox.style.height = '';
        mediaBox.style.minHeight = '';
        mediaBox.style.paddingTop = '';
      }
      if (container) {
        container.style.width = '';
        container.style.maxWidth = '';
      }
      if (mediaWrapper) mediaWrapper.removeAttribute('data-pdp-fill');
    }

    function updateRoot(root) {
      try {
        if (!root || !root.querySelector) return;

        var mediaWrapper = root.querySelector('.product__media-wrapper');
        if (!mediaWrapper) return;

        var container = mediaWrapper.querySelector('.product-media-container');
        var mediaBox = mediaWrapper.querySelector(
          '.product-media-container .product__media.media'
        );

        // Not desktop or not a single image: let CSS/Dawn govern entirely.
        if (!isDesktop() || !singleImage(mediaWrapper)) {
          relinquish(mediaBox, container, mediaWrapper);
          return;
        }
        if (!container || !mediaBox) return;

        // Truth = the flex-stretched wrapper height, which the CSS ::before
        // floor already keeps >= the image's natural height (--media-ratio).
        // Re-assert that floor here too so browsers without :has() get the
        // same result: box = max(info column, image natural height).
        var rect = mediaWrapper.getBoundingClientRect();
        var wrapH = rect ? rect.height : 0;
        var w = mediaWrapper.clientWidth || (rect ? rect.width : 0) || 0;
        if (w <= 0) return; // hidden / zero-width: bail, touch nothing

        var ratio = parseFloat(
          getComputedStyle(mediaWrapper).getPropertyValue('--media-ratio')
        );
        if (!ratio || ratio <= 0) ratio = 1;

        var target = Math.ceil(Math.max(wrapH, w / ratio));
        if (target <= 0) return;

        // Snap to an integer box: explicit px height wins over the ratio-padding
        // box and constrain-height cap; ceil guarantees full coverage (>= wrapper),
        // the extra <=1px is clipped by the overflow:hidden wrapper (grey, cover).
        mediaBox.style.paddingTop = '0px';
        mediaBox.style.height = target + 'px';
        mediaBox.style.minHeight = target + 'px';

        // Fallback fill for engines without :has() (harmless where CSS already did it).
        container.style.width = '100%';
        container.style.maxWidth = '100%';
        mediaWrapper.setAttribute('data-pdp-fill', '');
      } catch (e) {
        /* never throw into the page */
      }
    }

    function roots() {
      return document.querySelectorAll('product-info');
    }

    function updateAll() {
      var list = roots();
      for (var i = 0; i < list.length; i++) updateRoot(list[i]);
    }

    // Debounce everything through a single rAF.
    var rafId = null;
    function schedule() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        rafId = null;
        updateAll();
      });
    }

    // Observe the media-wrapper: its height already reflects the flex-equalized
    // max(9:16, infoColumn). We write only to its out-of-flow descendant, so this
    // cannot re-fire from our own write -> no feedback loop.
    var ro = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    var mo = 'MutationObserver' in window ? new MutationObserver(schedule) : null;

    function bindRoot(root) {
      try {
        if (!root || root.__pdpBound) return;
        root.__pdpBound = true;
        var mediaWrapper = root.querySelector('.product__media-wrapper');
        if (!mediaWrapper) return;
        if (ro) ro.observe(mediaWrapper);
        if (mo) {
          // Variant swaps replace the <img>/media DOM.
          mo.observe(mediaWrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['src', 'srcset', 'class', 'style']
          });
        }
      } catch (e) {}
    }

    function bindAll() {
      var list = roots();
      for (var i = 0; i < list.length; i++) bindRoot(list[i]);
    }

    function init() {
      bindAll();
      schedule();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Fonts + late images change info height / intrinsics.
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(schedule).catch(function () {});
    }

    // Width changes still re-snap the box.
    window.addEventListener('resize', schedule);
    if (mql) {
      if (mql.addEventListener) mql.addEventListener('change', schedule);
      else if (mql.addListener) mql.addListener(schedule); // legacy Safari
    }

    // Accordion open/close: <details> 'toggle' does not bubble -> capture phase.
    document.addEventListener('toggle', schedule, true);

    // Theme editor + variant changes.
    document.addEventListener('shopify:section:load', function () {
      bindAll();
      schedule();
    });
    document.addEventListener('variant:change', schedule);
    document.addEventListener('on:variant:change', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    class NewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'dyrehoj:newsletter-popup';
        this.delay = parseInt(this.dataset.delay, 10) || 0;
        this.daysHidden = parseInt(this.dataset.daysHidden, 10) || 7;
        this.scrollTrigger = this.dataset.scrollTrigger === 'true';
        this.wasOpened = false;

        this.querySelector('.newsletter-popup__close').addEventListener('click', () => this.close());
        this.addEventListener('click', (event) => {
          if (event.target === this) this.close();
        });
        this.onKeyUp = (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
        };

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.target.contains(this)) this.open();
          });
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.target.contains(this)) this.close(true);
          });
          return;
        }

        this.querySelector('form').addEventListener('submit', () => {
          this.setState({ subscribed: true });
        });

        const state = this.getState();
        if (state.subscribed) return;
        if (state.dismissedAt && Date.now() - state.dismissedAt < this.daysHidden * 86400000) return;

        this.timer = setTimeout(() => this.open(), this.delay * 1000);
        if (this.scrollTrigger) {
          this.onScroll = () => {
            if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 300) {
              this.open();
            }
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
      }

      open() {
        if (this.wasOpened) return;
        this.wasOpened = true;
        this.clearTriggers();
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keyup', this.onKeyUp);
        const dialog = this.querySelector('[role="dialog"]');
        if (typeof window.trapFocus === 'function') {
          window.trapFocus(this, dialog);
        } else {
          dialog.focus();
        }
      }

      close(skipStorage) {
        this.clearTriggers();
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keyup', this.onKeyUp);
        if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
        if (!skipStorage && this.wasOpened) {
          const state = this.getState();
          if (!state.subscribed) this.setState({ dismissedAt: Date.now() });
        }
      }

      clearTriggers() {
        if (this.timer) clearTimeout(this.timer);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }

      getState() {
        try {
          return JSON.parse(window.localStorage.getItem(this.storageKey)) || {};
        } catch (error) {
          return {};
        }
      }

      setState(patch) {
        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(Object.assign(this.getState(), patch)));
        } catch (error) {
          // localStorage unavailable (private mode) — popup just shows every visit
        }
      }
    }
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-image-banner"] && !Shopify.designMode) return;
  try {
    
  class SimpleImageBanner extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.simple-image-banner__slide'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.reducedMotion.matches) this.play();
      this.reducedMotion.addEventListener('change', () => {
        this.reducedMotion.matches ? this.pause() : this.play();
      });
    }

    disconnectedCallback() {
      this.pause();
    }

    play() {
      this.pause();
      this.interval = setInterval(() => this.next(), this.speed);
    }

    pause() {
      clearInterval(this.interval);
    }

    next() {
      const current = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const upcoming = this.slides[this.index];

      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      upcoming.classList.add('is-active');
      upcoming.removeAttribute('aria-hidden');
    }
  }

  customElements.define('simple-image-banner', SimpleImageBanner);

  } catch(e) { console.error(e); }
})();
})();
